import ReactDOM from "react-dom/client";
import "@pathofdev/react-tag-input/build/index.css";
import * as Sentry from "@sentry/react";
import "../src/assets/css/global.scss";
import reportWebVitals from "./reportWebVitals";

import "antd/dist/antd.css";
import "./tailwind.css";
import App from "./App";
import "./index.css";

// Vite injects VITE_* vars vào import.meta.env (không phải process.env)
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const SENTRY_ENV = (import.meta.env.VITE_SENTRY_ENVIRONMENT as string) ?? "development";

Sentry.init({
  dsn: SENTRY_DSN,
  environment: SENTRY_ENV,
  // Bật debug để thấy log chi tiết trong browser console (tắt sau khi verify xong)
  debug: SENTRY_ENV !== "production",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: SENTRY_ENV === "production" ? 0.1 : 1.0,
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/obranding\.vn\/api/,
    /^https:\/\/nft\.monbase\.com/,
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
